import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "outer-bg"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "row-column"
};
const _hoisted_4 = {
  class: "row-column"
};
const _hoisted_5 = {
  class: "row-column"
};
import { onMounted, ref, reactive } from 'vue';
import { useBigScreen } from '@/hooks/useBigScreen.js';
import CampusHeader from './components/CampusHeader.vue';
import BaseData from './components/BaseData.vue';
import MonthHotCookbook from './components/MonthHotCookbook.vue';
import MonthHotMeal from './components/MonthHotMeal.vue';
import ContentmentList from './components/ContentmentList.vue';
import BannerList from './components/BannerList.vue';
import nullImg from '@/assets/images/screen/null.png';
import { platformBaseData, platformHotData, platformEvaluationData, platformTodayData } from '@/api/index';
export default {
  __name: 'school',
  setup(__props) {
    let screen = ref();
    onMounted(() => {
      useBigScreen(screen);
      getBaseData();
      getHotData();
      getEvaluationData();
      getTodayData();
    });

    // API 获取基础数据
    let baseInfo = reactive({
      unitNumber: 0,
      dailyActiveNumber: 0,
      monthlyActiveNumber: 0,
      goodsNumber: 0,
      recipeNumber: 0,
      setMealNumber: 0
    });
    function getBaseData() {
      platformBaseData().then(data => {
        for (let key in baseInfo) {
          baseInfo[key] = data[key] || 0;
        }
      });
    }
    // API 获取热门数据
    let cookbookList = ref([]);
    let mealList = ref([]);
    function getHotData() {
      platformHotData().then(data => {
        let {
          recipeList,
          setMealList
        } = data;
        let cookbook = recipeList?.map(item => {
          return {
            id: item.id,
            name: item.name,
            url: item?.coverImage?.url || nullImg
          };
        });
        cookbookList.value = cookbook.length > 3 ? cookbook.slice(0, 3) : cookbook;
        let meal = setMealList?.map(item => {
          let urlList = [];
          for (let url of item.recipeList) {
            if (url?.coverImage?.url && urlList.length < 4) {
              urlList.push(url.coverImage.url);
            }
          }
          for (let i = urlList.length; i < 4; i++) {
            urlList.push(nullImg);
          }
          return {
            id: item.id,
            name: item.name,
            urlList: urlList
          };
        });
        mealList.value = meal.length > 3 ? meal.slice(0, 3) : meal;
      });
    }
    // API 获取满意度数据
    let evaluationList = ref([]);
    function getEvaluationData() {
      platformEvaluationData().then(data => {
        let dataList = data || [];
        evaluationList.value = dataList.map(item => {
          return {
            id: item?.unitVO?.id,
            ratio: keep2Decimal(item?.totalEvaluationSatisfaction),
            cityName: item?.unitVO?.addressCity?.regionName,
            companyName: item?.unitVO?.name
          };
        });
      });
    }
    // API 今日食谱
    let todayList = ref([]);
    let colorList = ['#6fe881', '#ff871f', '#f9dd47', '#1fb4ff', '#c8db50'];
    function getTodayData() {
      let arrList = [];
      platformTodayData().then(data => {
        let dataList = data || [];
        dataList.forEach(item => {
          let unitName = item?.unit?.name || '';
          let mealName = item?.mealTimes?.name || '';
          // 菜谱
          if (item?.recipeList?.length > 0) {
            let urlList = [];
            let recipeNames = item.recipeList.reduce((acc, recipe) => {
              if (recipe?.coverImage?.url && urlList.length < 3) {
                urlList.push(recipe.coverImage.url);
              }
              if (recipe.name) {
                acc = acc ? acc + '、' + recipe.name : recipe.name;
              }
              return acc;
            }, '');
            for (let i = urlList.length; i < 3; i++) {
              urlList.push(nullImg);
            }
            let nutritionList = [];
            item.recipeNutritionList.forEach((eneray, index) => {
              if (index < 5) {
                eneray['bgColor'] = colorList[index];
                eneray.proportion = keep2Decimal(eneray.proportion * 100);
                eneray.recommendedValue = eneray.recommendedValue > 100 ? 100 : eneray.recommendedValue;
                nutritionList.push(eneray);
              }
            });
            let obj = {
              name: `${unitName}：今日${mealName}(菜单)`,
              subname: recipeNames,
              urlList: urlList,
              nutritionList
            };
            arrList.push(obj);
          }
          // 套餐
          if (item?.setMealList?.length > 0) {
            item.setMealList.forEach(meal => {
              let urlList = [];
              let recipeNames = meal.recipeList.reduce((acc, recipe) => {
                if (recipe?.coverImage?.url && urlList.length < 3) {
                  urlList.push(recipe.coverImage.url);
                }
                if (recipe.name) {
                  acc = acc ? acc + '、' + recipe.name : recipe.name;
                }
                return acc;
              }, '');
              for (let i = urlList.length; i < 3; i++) {
                urlList.push(nullImg);
              }
              let nutritionList = [];
              meal.recipeNutritionList.forEach((eneray, index) => {
                if (index < 5) {
                  eneray['bgColor'] = colorList[index];
                  eneray.proportion = keep2Decimal(eneray.proportion * 100);
                  eneray.recommendedValue = eneray.recommendedValue > 100 ? 100 : eneray.recommendedValue;
                  nutritionList.push(eneray);
                }
              });
              let obj = {
                name: `${unitName}：今日${mealName}(${meal.name})`,
                subname: recipeNames,
                urlList: urlList,
                nutritionList
              };
              arrList.push(obj);
            });
          }
        });

        // 格式成二维数组
        todayList.value = [];
        for (let i = 0; i < arrList.length; i += 3) {
          todayList.value.push(arrList.slice(i, i + 3));
        }
      });
    }
    // 小数处理
    function keep2Decimal(num) {
      if (isNaN(num)) return NaN;
      return Number.isInteger(+num) ? +num : Number((+num).toFixed(2));
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "page",
        ref_key: "screen",
        ref: screen
      }, [_createVNode(CampusHeader), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(BaseData, {
        "base-info": _unref(baseInfo)
      }, null, 8, ["base-info"])]), _createElementVNode("div", _hoisted_4, [_createVNode(MonthHotCookbook, {
        "cookbook-list": _unref(cookbookList)
      }, null, 8, ["cookbook-list"]), _createVNode(MonthHotMeal, {
        "meal-list": _unref(mealList)
      }, null, 8, ["meal-list"]), _createVNode(ContentmentList, {
        "evaluation-list": _unref(evaluationList)
      }, null, 8, ["evaluation-list"])]), _createElementVNode("div", _hoisted_5, [_createVNode(BannerList, {
        "today-list": _unref(todayList)
      }, null, 8, ["today-list"])])])], 512)]);
    };
  }
};